import Button from "@pathwright/ui/src/components/button/Button"
import Pathicon from "@pathwright/ui/src/components/pathicon/Pathicon"
import View from "@pathwright/ui/src/components/ui/View"
import BrowseContainer from "@pathwright/features/src/modules/library/browse/BrowseContainer"
import { usePathwrightContext } from "@pathwright/features/src/modules/pathwright/PathwrightContext"
import { useCanViewSimpleNav } from "@pathwright/features/src/modules/unified-home/view-permission/useUnifiedHomePermissions"
import { canEditLibrary } from "@pathwright/features/src/modules/user/permissions"
import Footer from "global/footer/components/Footer"
import * as urls from "lib/core/utils/urls"
import React from "react"
import "./LibraryBrowse.css"
import FeatureBanners from "./banner/FeatureBanners"

const LibraryBrowse = ({ children, location }) => {
  const pwContext = usePathwrightContext()
  const canViewUnifiedHome = useCanViewSimpleNav()

  // ensure school name is set in tab
  React.useEffect(() => {
    App.getStore("navigation").action.setURLTitle(pwContext.school.name)
  }, [])

  return (
    <View.Primary className="LibraryBrowse">
      <div className="LibraryBrowse__container">
        <FeatureBanners />
        {canEditLibrary(pwContext) && canViewUnifiedHome === false && (
          <Button
            to={urls.modalRoute("/manage/library/")}
            className="LibraryBrowse__edit"
            styleType="secondary"
            inverted
          >
            <Pathicon icon="gear" />
            <span> Library Settings</span>
          </Button>
        )}
        <BrowseContainer />
        <Footer location="Library" />
      </div>
      {/* Rendering any children (think Modals that need shared context) */}
      {children}
    </View.Primary>
  )
}

export default LibraryBrowse
